(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-highlights"]) return;
  try {
    
  (function () {
    function positionCollectionHighlights() {
      var highlights = document.querySelector(
        '[data-collection-highlights][data-collection-page="true"]'
      );

      if (!highlights) return;

      var collectionMain = document.querySelector(
        '#shopify-section-collection-template .CollectionMain'
      );

      var sectionWrapper = document.getElementById(
        'shopify-section-' + highlights.dataset.sectionId
      );

      if (
        collectionMain &&
        sectionWrapper &&
        !sectionWrapper.contains(collectionMain)
      ) {
        collectionMain.parentNode.insertBefore(
          sectionWrapper,
          collectionMain
        );
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        positionCollectionHighlights,
        { once: true }
      );
    } else {
      positionCollectionHighlights();
    }

    document.addEventListener(
      'shopify:section:load',
      positionCollectionHighlights
    );

    document.addEventListener(
      'shopify:section:reorder',
      positionCollectionHighlights
    );
  })();

  } catch(e) { console.error(e); }
})();
})();
